import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  HomeIcon, 
  ChartBarIcon, 
  UserGroupIcon, 
  PlusCircleIcon,
  StarIcon,
  ArrowsRightLeftIcon,
  UserIcon
} from '@heroicons/react/24/outline';

const Sidebar: React.FC = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const navigation = [
    { name: 'Dashboard', icon: HomeIcon, href: '/' },
    { name: 'Add Metrics', icon: PlusCircleIcon, href: '/add-metrics' },
    { name: 'Artist Detail', icon: ChartBarIcon, href: '/artist/me' },
    { name: 'Comparisons', icon: ArrowsRightLeftIcon, href: '/comparisons' },
    { name: 'Favorites', icon: StarIcon, href: '/favorites' },
    { name: 'Browse Artists', icon: UserGroupIcon, href: '/browse' },
    { name: 'Your Profile', icon: UserIcon, href: '/profile' },
  ];

  return (
    <div className={`bg-green-800 ${collapsed ? 'w-16' : 'w-64'} transition-width duration-150 ease-in-out`}>
      <div className="h-16 flex items-center justify-between px-4">
        {!collapsed && (
          <span className="text-white font-bold text-lg">Artist Tracker</span>
        )}
        <button 
          onClick={() => setCollapsed(!collapsed)}
          className="text-green-200 hover:text-white"
        >
          {collapsed ? '→' : '←'}
        </button>
      </div>
      <nav className="mt-5 px-2">
        <div className="space-y-1">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`
                  ${isActive
                    ? 'bg-green-900 text-white'
                    : 'text-green-100 hover:bg-green-700 hover:text-white'
                  }
                  ${collapsed ? 'justify-center' : 'justify-start'}
                  group flex items-center px-2 py-2 text-sm font-medium rounded-md
                `}
              >
                <item.icon
                  className={`
                    ${isActive ? 'text-white' : 'text-green-300 group-hover:text-white'}
                    mr-3 flex-shrink-0 h-6 w-6
                  `}
                  aria-hidden="true"
                />
                {!collapsed && <span>{item.name}</span>}
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;